/**
 * @file: ReservationRemarksCard.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The booking remark, shown as its own card when present.
 */

import { Typography } from '@euler/app/components/typography';
import {
  LD,
  cardShadowStyle,
} from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';

export const ReservationRemarksCard = memo(({ remark }: { remark: string }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View>
      <Typography.Text
        size={rpx(16)}
        color={LD.ink}
        bold
        style={{
          marginTop: rpx(18),
          marginBottom: rpx(10),
          marginLeft: rpx(2),
        }}
      >
        备注
      </Typography.Text>
      <View
        style={{
          backgroundColor: LD.surface,
          borderRadius: rpx(14),
          padding: rpx(16),
          ...cardShadowStyle(rpx),
        }}
      >
        <Typography.Text size={rpx(14)} color={LD.steel} lineHeight={rpx(21)}>
          {remark}
        </Typography.Text>
      </View>
    </View>
  );
});
